import React, { lazy, Suspense } from 'react'
import Loader from 'components/Reusable/Loader'

const CheckoutSection = lazy(() => import('components/Sections/Checkout'))
const Footer = lazy(() => import('components/Layout/Footer'))

function Order() {
    const loader = () => <Loader />

    const MainComponent = () => (
        <Suspense fallback={loader()}>
            <CheckoutSection />
            <Footer />
        </Suspense>
    )

    return MainComponent()
}

export default Order